import { createContext, useContext } from 'react';
import type { Locale, StringKey } from './strings';

export type TemplateVars = Record<string, string | number>;

export type I18nContextValue = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: StringKey, vars?: TemplateVars) => string;
};

export const I18nContext = createContext<I18nContextValue | undefined>(undefined);

export function useI18n(): I18nContextValue {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return ctx;
}
